export default __webpack_public_path__ + "static/media/logo_cellar_watch.800e5c1a.png";